import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink, Link } from 'react-router-dom'
import { ReactComponent as FooterLogo } from '../assets/JeffersonCorporateEnterpriseFooter.svg'
import { Container, Grid, Box, makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 60,
    paddingBottom: 180,
  },
  content: {
    maxWidth: 620,
  },
  heading: {
    fontSize: '32px',
    fontWeight: 700,
    marginBottom: 20,
  },
  logo: {
    marginRight: 45,
  },
  linkContainerDrawer: {
    margin: `0 1.5rem 1.25rem 0`,
    minWidth: `298px`,
    fontSize: '18px',
    fontWeight: 700,
  },
  link: {
    cursor: `pointer`,
    color: `white`,
    fontSize: `0.75rem`,
    marginRight: `1rem`,
    textDecoration: `none`,
    [theme.breakpoints.up('md')]: {
      fontSize: `0.75rem`,
      marginRight: `2rem`,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: `1rem`,
    },
  },
  activeLink: {
    borderBottom: `2px solid white`,
    cursor: 'default',
  },
  mobileFiltersOpen: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}))

const PROJECT_SUBMISSION_LINK = process.env.REACT_APP_PROJECT_SUBMISSION_LINK

const Footer = () => {
  const classes = useStyles()
  const { viewFiltersStatus } = useSelector((state) => state.projectBoard)

  return (
    <Box
      className={clsx(classes.root, viewFiltersStatus && classes.mobileFiltersOpen)}
      bgcolor="primary.main"
      color="primary.contrastText"
    >
      <Container style={{ maxWidth: 1640, padding: '0px 36px' }}>
        <Grid className={classes.content} container>
          <Grid className={classes.heading} container alignItems="center">
            <Grid className={classes.logo} item>
              <FooterLogo />
            </Grid>
          </Grid>

          <Grid className={classes.linkContainerDrawer} container>
            <NavLink
              activeClassName={classes.activeLink}
              exact
              to="/"
              className={classes.link}
            >
              Project Board
            </NavLink>

            <a
              href={PROJECT_SUBMISSION_LINK}
              className={classes.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Submit Project
            </a>

            <NavLink
              activeClassName={classes.activeLink}
              to="/about"
              className={classes.link}
            >
              About
            </NavLink>
          </Grid>

          <Grid container>
            <p>
              The website for Thomas Jefferson University Hospitals, its contents and programs, is
              provided for informational and educational purposes only and is not intended as
              medical advice nor, is it intended to create any physician-patient relationship.
              Please remember that this information should not substitute for a visit or a
              consultation with a healthcare provider.
            </p>
            <p>
              The views or opinions expressed in the resources provided do not necessarily reflect
              those of Thomas Jefferson University Hospitals, Thomas Jefferson University or their
              staffs. By using this web site, you accept these{' '}
              <Link
                color="secondary"
                to="http://hospitals.jefferson.edu/patients-and-visitors/patient-policies/terms-of-use/"
              >
                terms of use
              </Link>
              . Please read our{' '}
              <Link
                color="secondary"
                to="http://hospitals.jefferson.edu/patients-and-visitors/patient-policies/online-privacy-statement/"
              >
                online privacy statement
              </Link>
              . Please read our{' '}
              <Link
                color="secondary"
                to="http://hospitals.jefferson.edu/patients-and-visitors/patient-policies/privacy-practices/"
              >
                privacy practices
              </Link>
              .
            </p>
            <p>
              &copy; 2020 All Rights Reserved. Thomas Jefferson University &amp; Jefferson Health
            </p>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Footer
